document.addEventListener('DOMContentLoaded', function () {

  /* ---- Mobile hamburger menu ---- */
  var hamburger = document.getElementById('hamburgerBtn');
  var drawer = document.getElementById('mobileDrawer');
  var overlay = document.getElementById('mobileDrawerOverlay');
  var closeBtn = document.getElementById('mobileDrawerClose');

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    hamburger.setAttribute('aria-expanded', 'true');
  }
  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
  }
  if (hamburger) hamburger.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { observer.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---- Product page thumbnail gallery ---- */
  var mainImage = document.getElementById('mainProductImage');
  var thumbs = document.querySelectorAll('.product-page__thumb');
  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.getAttribute('data-full');
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
    if (i === 0) thumb.classList.add('is-active');
  });

  /* ---- Product accordion ---- */
  var accordionTriggers = document.querySelectorAll('[data-accordion]');
  accordionTriggers.forEach(function (trigger) {
    var panel = trigger.nextElementSibling;
    trigger.addEventListener('click', function () {
      var isOpen = trigger.classList.contains('is-open');
      accordionTriggers.forEach(function (t) {
        t.classList.remove('is-open');
        t.nextElementSibling.style.maxHeight = null;
      });
      if (!isOpen) {
        trigger.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* ---- AJAX add-to-cart with cart counter bump ---- */
  var cartForms = document.querySelectorAll('.add-to-cart-form');
  var cartCount = document.getElementById('cartCount');

  cartForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var submitBtn = form.querySelector('button[type="submit"]');
      var originalText = submitBtn.textContent;
      submitBtn.textContent = 'Adding…';
      submitBtn.disabled = true;

      var formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (res) { return res.json(); });
        })
        .then(function (cart) {
          if (cartCount) {
            cartCount.textContent = cart.item_count;
            cartCount.classList.add('bump');
            setTimeout(function () { cartCount.classList.remove('bump'); }, 350);
          }
          submitBtn.textContent = 'Added';
          setTimeout(function () {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 1200);
        })
        .catch(function () {
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
          window.location.href = '/cart';
        });
    });
  });

  /* ---- Buy Now: add to cart then go straight to Shopify's checkout ---- */
  var buyNowBtn = document.querySelector('[data-buy-now]');

  if (buyNowBtn) {
    buyNowBtn.addEventListener('click', function () {
      var variantId = buyNowBtn.getAttribute('data-variant-id');
      var qtyField = document.getElementById('qty');
      var quantity = qtyField ? qtyField.value : 1;
      var originalText = buyNowBtn.textContent;
      buyNowBtn.textContent = 'Redirecting…';
      buyNowBtn.disabled = true;

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', quantity);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          buyNowBtn.textContent = originalText;
          buyNowBtn.disabled = false;
          window.location.href = '/cart';
        });
    });
  }

});